import { Injectable } from '@angular/core';
import { Device, ScreenSize } from '../../model/device-type.interface';

@Injectable({
  providedIn: 'root'
})
export class DeviceTypeService {
  getDeviceType = (): Device => {
    const screenSize = window.innerWidth;
    return {
      isDesktop: screenSize > ScreenSize.SIZE_991,
      isTablet:
        screenSize <= ScreenSize.SIZE_991 && screenSize >= ScreenSize.SIZE_768,
      isMobile:
        screenSize < ScreenSize.SIZE_768 && screenSize >= ScreenSize.SIZE_768
    };
  };
}
